import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { DataSessionService } from '../services/data-session.service';
import { LOCAL_STORAGE_TOKEN, ROUTES_AUTH } from '../constants/constants';

export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    let token = localStorage.getItem(LOCAL_STORAGE_TOKEN);
    const dataSessionService = inject(DataSessionService);

    if (ROUTES_AUTH.some((endpoint) => req.url.includes(endpoint))) {
         token = localStorage.getItem('recaptcha_token');
    }

    if (token) {
        const modifiedRequest = req.clone({
            setHeaders: {
                Authorization: token,
            },
        });

        return next(modifiedRequest).pipe(
            catchError((error: HttpErrorResponse) => {
               
                if (error.status === 401) {
                    dataSessionService.closeSesionAuto();
                }
                return throwError(() => error);
            }),
        );
    }
    return next(req);
};

